import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Panel} from "primereact/panel";
import {InputSwitch} from "primereact/inputswitch";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Dialog} from "primereact/dialog";
import axios from "axios";

import ProjectitemstatusFormService from '../_services/projectitemstatus/ProjectitemstatusFormService'
import {Dropdown} from "primereact/dropdown";

const ProjectitemstatusFormComponent = (props) => {

  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [projectItemStatusRules, setProjectItemStatusRules] = useState([]);
  const [productionItemStatuses, setProductionItemStatuses] = useState([]);
  const [technologies, setTechnologies] = useState([]);
  const [selectedProductionItemStatus, setSelectedProductionItemStatus] = useState('');
  const [selectedTechnology, setSelectedTechnology] = useState(null);
  const [ruleDialog, setRuleDialog] = useState(false);


  const validate = (data) => {
    let errors = {};
    // if (!data.name) {
    //   errors.name = 'Az megnevezés nem lehet üres';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    setFormData({
      ...formData,
      data
    });
    if (props && props.initialValues) {
      ProjectitemstatusFormService(data, 'put')
        .then(response => {
          window.App.toastShow('success', 'Sikeres módosítás!');
          window.App.setState({
            rerenderProjectitemstatusList: true,
            sidebarProjectitemstatusUpdate: false
          })
          setLoading(false)
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
          setLoading(false)
        })
    } else {
      ProjectitemstatusFormService(data, 'post')
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({
            rerenderProjectitemstatusList: true,
            sidebarProjectitemstatusCreate: false
          })
          setLoading(false)
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
          setLoading(false)
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  useEffect(() => {
    if (props && props.initialValues) {
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_HOST + "/api/v2/project-item-status/" + props.initialValues.id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
        .then(response => {
          setFormData(response.data.data)
          setProjectItemStatusRules(response.data.data.rules)
          setLoading(false)
        })
        .catch(error => {
          setLoading(false)
        })
    }
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/dictionary/production-status",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(response => {
        setProductionItemStatuses(response.data.data)
      })
      .catch(error => {

      })
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/technology",
      params: {rows: 1000},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(response => {
        setTechnologies(response.data.data)
      })
      .catch(error => {

      })
  }, [])

  return (
    <Form onSubmit={onSubmit} initialValues={formData}
          validate={validate} render={({handleSubmit}) => (
      <form onSubmit={handleSubmit} className="">
        <Panel headerTemplate={
          <div className={"p-grid"}>
            <div className={"p-col-12"}>
              <h3>
                <i className={"pi pi-list"}></i> Alapadatok
              </h3>
            </div>
          </div>
        } className={""}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-2"}>
              <Field name="active" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="active"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>Aktív</label>
                  <span className="p-d-block">
                    <InputSwitch
                      className={"p-mt-1"}
                      checked={formData.active}
                      value={formData.active}
                      onChange={e => setFormData({...formData, active: e.target.value})}/>
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-10 p-xl-10"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>Megnevezés</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
              <Button type="submit" label="Mentés" icon={"pi pi-check"} loading={loading}
                      className="p-button-success"/>
            </div>
          </div>
        </Panel>
        {formData.id &&
          <Panel className={"p-mt-3"} headerTemplate={
            <div className={"p-grid"}>
              <div className={"p-col-12"}>
                <h3>
                  <i className={"pi pi-list"}></i> Szabályok
                </h3>
              </div>
            </div>
          }>
            <DataTable size={localStorage.getItem('scale')}
                       emptyMessage="Nincs találat."
                       value={projectItemStatusRules} loading={loading}
                       autoLayout={true}
                       filterDisplay="row"
                       responsiveLayout="scroll"
                       stripedRows
            >
              <Column header="Feladat státusz" body={(rowData) => {
                return(
                  <span>{rowData.production_item_status}</span>
                )
              }}></Column>
              <Column header="Technológia" body={(rowData) => {
                return(
                  <span>{rowData.technology ? rowData.technology.name : 'Bármely technológia'}</span>
                )
              }}></Column>
              <Column body={() => {
                return (
                  <i className={"pi pi-arrow-right"}></i>
                )
              }}/>
              <Column field="project_item_status.name" header="Projekt tétel státusz"
                      body={() => {
                        return(
                          <span>{formData.name}</span>
                        )
                      }}
              ></Column>
            </DataTable>
            <div className={"p-grid p-mt-1"}>
              <div className={"p-col-12 p-lg-6 p-xl-6"}>

              </div>
              <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
                <Button type="button" label="Új szabály" icon={"pi pi-plus"} loading={loading}
                        onClick={() => {
                          setRuleDialog(true)
                        }}
                        className="p-button-success"/>
                <Dialog visible={ruleDialog}
                        style={{width: '750px'}}
                        header="Új szabály hozzáadása"
                        modal
                        onHide={() => {
                          setRuleDialog(false)
                        }}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-12"}>
                      <div className="p-field p-fluid">
                        <label htmlFor="production_item_status">Feladat státusz</label>
                        <span className="p-d-block">
                        <Dropdown options={productionItemStatuses}
                                  optionLabel="value"
                                  optionValue="key"
                                  id={"production_item_status"}
                                  emptyMessage={"Még nincs státusz..."}
                                  onChange={(e) => {
                                    setSelectedProductionItemStatus(e.value)
                                  }}
                                  value={selectedProductionItemStatus}
                        />
                      </span>
                      </div>
                    </div>
                    <div className={"p-col-12 p-lg-12"}>
                      <div className="p-field p-fluid">
                        <label htmlFor="technology">Technológia (opcionális)</label>
                        <Dropdown options={technologies}
                                  optionLabel="name"
                                  optionValue="id"
                                  id={"technology"}
                                  placeholder="Bármely technológia"
                                  showClear
                                  filter
                                  onChange={(e) => {
                                    setSelectedTechnology(e.value)
                                  }}
                                  value={selectedTechnology}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={"p-grid p-mt-1"}>
                    <div className={"p-col-12 p-lg-6 p-xl-6"}>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
                      <Button type="button" label="Mentés" icon={"pi pi-save"} loading={loading}
                              onClick={() => {
                                setLoading(true)
                                axios({
                                  method: 'post',
                                  data: {
                                    production_item_status: selectedProductionItemStatus.toLowerCase(),
                                    project_item_status: formData.id,
                                    technology: selectedTechnology
                                  },
                                  url: process.env.REACT_APP_API_HOST + "/api/v2/project-item-status-rule",
                                  params: {},
                                  headers: {
                                    'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                                    'App-Network': localStorage.getItem("networkId")
                                  }
                                })
                                  .then(response => {
                                    window.App.toastShow('success', 'Sikeres mentés!');
                                    setRuleDialog(false)
                                    axios({
                                      method: 'get',
                                      url: process.env.REACT_APP_API_HOST + "/api/v2/project-item-status/" + props.initialValues.id,
                                      params: {},
                                      headers: {
                                        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                                        'App-Network': localStorage.getItem("networkId")
                                      }
                                    })
                                      .then(response => {
                                        setFormData(response.data.data)
                                        setProjectItemStatusRules(response.data.data.rules)
                                        setLoading(false)
                                      })
                                      .catch(error => {
                                        setLoading(false)
                                      })
                                  })
                                  .catch(error => {
                                    window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                                    setLoading(false)
                                  })
                              }}
                              className="p-button-success"/>
                    </div>
                  </div>
                </Dialog>
              </div>
            </div>
          </Panel>
        }
      </form>
    )}/>
  )
}
export default withTranslation('common')(ProjectitemstatusFormComponent);
